export class EventEmitter {
    constructor() {
        this.callBacks = [];
        this.trigger = (...args) => {
            this.callBacks.forEach(cb => cb(...args));
        };
        this.addEventListener = (callback) => {
            this.callBacks.push(callback);
        };
        this.removeEventListener = (callback) => {
            this.callBacks = this.callBacks.filter(c => c !== callback);
        };
    }
}
